import { AfterViewInit, Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Status } from '../../../enums/status';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user.service';
import { StihlUserDTO } from 'src/app/models/stihl-user-dto';
import { CampaignOrderService } from 'src/app/services/campaign-order.service';
import { SharedService } from 'src/app/services/shared.service';
import { LanguageApp } from 'src/app/config/datatable-config';
import { Helpers } from 'src/app/helpers/helpers';


@Component({
  selector: 'app-table-order-pub',
  templateUrl: './table-order-pub.component.html'
})
export class TableOrderPubComponent implements AfterViewInit, OnInit {
  @Input() Origin: string = "";
  hdd_origin: string;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  listenerFn: () => void;
  actualOrder: string;
  loggedUser: StihlUserDTO = new StihlUserDTO();


  public distributorsList: any[] = [];

  defaultDistrib: string = '0';

  constructor(

    private campaignOrderService: CampaignOrderService,
    private router: Router,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private helper: Helpers,
    private userService: UserService,
    private sharedService: SharedService) {

  }

  ngAfterViewInit(): void {

    this.listenerFn = this.renderer.listen('document', 'click', (event) => {



      if (event.target.hasAttribute("edit-order-pub-id")) {
        if (this.Origin == 'stihl')
          this.router.navigate(["/area-stihl/orders-advertising/edit/" + event.target.getAttribute("edit-order-pub-id")]);
        else if (this.Origin == 'miArea')
          this.router.navigate(["/myarea/orders-advertising/edit/" + event.target.getAttribute("edit-order-pub-id")]);
      }

      if (event.target.hasAttribute("delete-order-pub-id")) {
        this.actualOrder = event.target.getAttribute("delete-order-pub-id");
        this.bajaCampaingOrder(this.actualOrder);
      }

    });
    this.helper.setDataTableSearchDelay();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    if (this.listenerFn) {
      this.listenerFn();
    }
  }

  ngOnInit(): void {

    this.getLists();

    this.setDatatable();
    this.hdd_origin = this.Origin;

  }

  getLists() {

    this.sharedService.getStihlDistributors().subscribe(res => {

      res.unshift({ value: '0', label: 'TODOS OS CONCESSIONÁRIOS' });
      this.distributorsList = res;
      console.log(this.distributorsList)
      this.getUser();

    });
  }

  getUser() {

    this.userService.getUserData().subscribe(res => {

      this.loggedUser = res;

      if (this.Origin != 'miArea') {
        this.defaultDistrib = '0';
      }
      else {
        this.defaultDistrib = this.loggedUser.IdDistributor.toString();
      }

      this.dtTrigger.next(null);


    });
  }

  rerender(): void {

    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.draw();
      });
    }

  }


  setDatatable() {
    const that = this;
    that.dtOptions = {
      responsive: false,
      paging: true,
      pageLength: 10,
      ordering: false,
      lengthChange: false,
      info: false,
      serverSide: true,
      language: LanguageApp.spanish_datatables,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        that.campaignOrderService.getDatatableOrderPub(dataTablesParameters, +that.defaultDistrib).subscribe(resp => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao recuperar os dados',
            text: 'Ocorreu um erro'
          });

        });
      },
      columns: [
        { data: "codDistributor", orderable: false },
        { data: "Distributor", orderable: false },
        { data: "User", orderable: false },
        { data: "Number", orderable: false },
        { data: "Date", orderable: false },
        { data: "Campaign", orderable: false },
        { data: "Media", orderable: false },
        { data: "IdCampaignOrderPub", orderable: false },
      ],
      columnDefs: [
        {
          targets: [0],
          data: "codDistributor",
          className: "text-center"
        },
        {
          targets: [3],
          data: "Number",
          className: "text-center"
        },
        {
          targets: [4],
          data: "Date",
          className: "text-center"
        },
        {
          targets: [5],
          data: "Campaign",
          className: "text-center"
        },
        {
          targets: [6],
          data: "media",
          className: "text-center"
        },
        {
          targets: [7],
          data: "IdCampaignOrderPub",
          render: function (data, type, full) {
            var retorno = '<a edit-order-pub-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_eye_auto.svg#img" href="assets/images/icons/ico_eye_auto.svg#img"></use></svg></div> Ver</a>';
              retorno += '<a delete-order-pub-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_trash_auto.svg#img" href="assets/images/icons/ico_trash_auto.svg#img"></use></svg></div> Eliminar</a>';
            return retorno;

          }
        }
      ],
      initComplete: function () {
        that.helper.animateDataTable(this[0])
      }
    };

  }


  bajaCampaingOrder(idOrder) {
    Swal.fire({
      title: 'Eliminar',
      text: "Tem certeza de que pretende continuar e remover o pedido de Email e SMS?",
      icon: 'warning',
      showCancelButton: true,
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn-orange-border mx-1',
        confirmButton: 'btn-orange mx-1'
      },
      confirmButtonText: 'Aceitar',
      cancelButtonText: "Cancelar",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.campaignOrderService.changeStatusOrderPub(idOrder, Status.Baja).subscribe(i => {
          this.rerender();
          Swal.fire(
            'Removido!',
            'O pedido selecionado foi removido.',
            'success'
          )
        })
      }
    })

  }

  DownloadExcelValla() {

    this.campaignOrderService.getCampaignOrderPubVallaExcel().subscribe(resp => {
      saveAs(resp, "pedido-outdoor.xlsx");

    });
  }

}
